import { render, staticRenderFns } from "./application.vue?vue&type=template&id=dad0f8f4"
import script from "./application.ts?vue&type=script&lang=js&external"
export * from "./application.ts?vue&type=script&lang=js&external"
import style0 from "./../../css/main.scss?vue&type=style&index=0&prod&rel=prelaod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports